import DomainManager from '../utils/DomainManager';
import mrtAxiosV2, { MrtAxiosOptions } from '../utils/mrtAxiosV2';

export const fetchInteractiveBanner = (
  targetEnv: string,
  screenName: string,
  sectionName: string,
  inventoryId?: string,
  options?: MrtAxiosOptions,
) => {
  const { isWebView } = options || {};
  const domainManager = new DomainManager(targetEnv);

  const params = new URLSearchParams({
    screenName,
    sectionName,
    ...(inventoryId && { inventoryId }),
  });

  return mrtAxiosV2(targetEnv, { isWebView }).get<any>(
    `${domainManager.getApiDomain()}/ad/v2/traveler/exposure/cpt/ad?${params.toString()}`,
  );
};
